import Cookies from 'js-cookie';
import qs from 'query-string';
import { useEffectOnce } from 'react-use';

export type UTMParameters = {
  utmCampaign: string;
  utmContent: string;
  utmMedium: string;
  utmSource: string;
  utmTerm: string;
};

export const getUTMParametersFromURL = (): UTMParameters => {
  const UTMCookie = Cookies.get('utm_params');
  let utmParams: Record<string, string> | undefined;

  try {
    utmParams = JSON.parse(`${UTMCookie}`);
  } catch {
    utmParams = undefined;
  }

  const URLquery = qs.parse(window.location.search);

  return {
    utmSource: (URLquery.utm_source as string) ?? utmParams?.['utm_source [last touch]'] ?? '',
    utmMedium: (URLquery.utm_medium as string) ?? utmParams?.['utm_medium [last touch]'] ?? '',
    utmCampaign: (URLquery.utm_campaign as string) ?? utmParams?.['utm_campaign [last touch]'] ?? '',
    utmContent: (URLquery.utm_content as string) ?? utmParams?.['utm_content [last touch]'] ?? '',
    utmTerm: (URLquery.utm_term as string) ?? utmParams?.['utm_term [last touch]'] ?? '',
  };
};

const UTM_PARAMS_STORAGE_KEY = 'expressable_utm_params';

export const getUTMParameters = (): UTMParameters | undefined => {
  const utmParams = Cookies.get(UTM_PARAMS_STORAGE_KEY);

  if (!utmParams) {
    return undefined;
  }

  try {
    return JSON.parse(utmParams);
  } catch {
    return undefined;
  }
};

/** Will load UTM trackers from URL and save it onto a cookie*/
export const useSaveUTMTrackers = () => {
  useEffectOnce(() => {
    const utmParams = getUTMParametersFromURL();

    if (utmParams) {
      Cookies.set(UTM_PARAMS_STORAGE_KEY, JSON.stringify(utmParams));
    }
  });
};
